function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEuropa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25948,0,0,1.52357,-5.38174,-3.17599)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.565,
    cy: 13.899,
    rx: 11.89,
    ry: 9.845,
    style: {
      fill: "rgb(0,51,153)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.8315,0,0,1.84547,18,17.9183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s",
    transform: "matrix(1,0,0,1,0,-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t1",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c1",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t2",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t3",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c2",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t4",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t5",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "a1",
    transform: "matrix(-1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c3",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t6",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t7",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c4",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t8",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t9",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "s1",
    transform: "matrix(1,0,0,1,0,6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t10",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t11",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "a2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c6",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t12",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t13",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c7",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t14",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t15",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "a3",
    transform: "matrix(-1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c8",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t16",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t17",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c9",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t18",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t19",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s2",
    transform: "matrix(1,0,0,1,-6,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t20",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t21",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "a4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c11",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t22",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t23",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c12",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t24",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t25",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "a5",
    transform: "matrix(-1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c13",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t26",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t27",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c14",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t28",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t29",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "s3",
    transform: "matrix(-0.809017,-0.587785,0.587785,-0.809017,-3,-5.19615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t30",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t31",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "a6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c16",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t32",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t33",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c17",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t34",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t35",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "a7",
    transform: "matrix(-1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c18",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t36",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t37",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c19",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t38",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t39",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "s4",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,-5.19615,-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t40",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t41",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "a8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c21",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t42",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t43",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c22",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t44",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t45",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "a9",
    transform: "matrix(-1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c23",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t46",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t47",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c24",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t48",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t49",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "s5",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,-5.19615,3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t50",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t51",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "a10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c26",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t52",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t53",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c27",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t54",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t55",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "a11",
    transform: "matrix(-1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c28",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t56",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t57",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c29",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t58",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t59",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "s6",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,-3,5.19615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t60",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t61",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "a12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c31",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t62",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t63",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c32",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t64",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t65",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "a13",
    transform: "matrix(-1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c33",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t66",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t67",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c34",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t68",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t69",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "l1",
    transform: "matrix(-1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s7",
    transform: "matrix(1,0,0,1,-6,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t70",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t71",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "a14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c36",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t72",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t73",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c37",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t74",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t75",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "a15",
    transform: "matrix(-1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c38",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t76",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t77",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c39",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t78",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t79",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "s8",
    transform: "matrix(-0.809017,-0.587785,0.587785,-0.809017,-3,-5.19615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t80",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t81",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "a16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c41",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t82",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t83",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c42",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t84",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t85",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "a17",
    transform: "matrix(-1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c43",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t86",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t87",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c44",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t88",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t89",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "s9",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,-5.19615,-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t90",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t91",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "a18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c46",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t92",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t93",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c47",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t94",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t95",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "a19",
    transform: "matrix(-1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c48",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t96",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t97",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c49",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t98",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t99",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "s10",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,-5.19615,3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t100",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t101",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "a20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c51",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t102",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t103",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c52",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t104",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t105",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "a21",
    transform: "matrix(-1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c53",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t106",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t107",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c54",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t108",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t109",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "s11",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,-3,5.19615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t110",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t111",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "a22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c56",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t112",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t113",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c57",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t114",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t115",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "a23",
    transform: "matrix(-1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c58",
    transform: "matrix(0.309017,0.951057,-0.951057,0.309017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t116",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t117",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c59",
    transform: "matrix(-0.809017,0.587785,-0.587785,-0.809017,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t118",
    transform: "matrix(0.951057,0.309017,-0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "t119",
    transform: "matrix(-0.951057,0.309017,0.309017,0.951057,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,1L0.5,1L0,0Z",
    style: {
      fill: "rgb(255,204,0)",
      fillRule: "nonzero"
    }
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuropa);
export default __webpack_public_path__ + "static/media/europa.b3efd7da47a96dd2ee34dabbd7039a51.svg";
export { ForwardRef as ReactComponent };